var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-viewer-container",style:({
  'top': 'calc(' + (_vm.innerWidth < 700 ? _vm.stop : _vm.top) + 'vh + 80px)', 
  'left': (_vm.innerWidth < 700 ? _vm.sleft : _vm.left) + 'vw', 
  'width': (_vm.innerWidth < 700 ? _vm.swidth : _vm.width) + 'vw',
  'height': 'calc(' + (_vm.innerWidth < 700 ? _vm.sheight : _vm.height) + 'vh - 80px)'
  })},[_c('div',{staticClass:"info-viewer-content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }